(function () {
    'use strict';
    angular.module('Services').service('TransitWarrantyRatesTableService', TransitWarrantyRatesTableService);
    TransitWarrantyRatesTableService.$inject = [
        'TransitWarrantyService',
        '$uibModal',
        'TableLiteFactory',
        'toastr',
        '$filter'
    ];

    function TransitWarrantyRatesTableService(
        TransitWarrantyService,
        $uibModal,
        TableLiteFactory,
        toastr,
        $filter
    ) {
        return function (defaultFilters = {}) {
            const tableStructure = {
                tableName: 'TransitWarrantyRatesTableService',
                config: {},
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Create New',
                        tooltip: 'Click to create a new rate',
                        onClick: showRateDetailsModal
                    }]
                },
                headers: [
                    {
                        label: 'Rate Name',
                        viewName: 'rateName',
                        filterName: 'rateName',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Warranty Provider',
                        viewName: 'provider',
                        filterName: 'warrantyProvider.name',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Coverage Amount',
                        viewName: 'coverageAmountFormatted',
                        filterName: 'coverageAmount',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Rate',
                        viewName: 'rateFormatted',
                        filterName: 'rate',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Carrier',
                        viewName: 'carrierProfilesFormatted',
                        filterName: 'carrierProfiles',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Margin',
                        viewName: 'marginFormatted',
                        filterName: 'margin',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Excess',
                        viewName: 'excessFormatted',
                        filterName: 'excess',
                        filter: {
                            type: 'text',
                            onSubmit: (header) => {
                                tableActions.sendRequest(tableActions.evaluateFilter(header))
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Status',
                        viewName: 'status',
                        filterName: 'active',
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Actions',
                        viewName: 'actions'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: TransitWarrantyService.Rates.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: error => {
                    buildTableData(null);
                    toastr.error(error);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (row) => {
                    row.provider = row.warrantyProvider.name || 'N/A'
                    row.rateFormatted = $filter('bbaCurrency')(row.rate);
                    row.coverageAmountFormatted = $filter('bbaCurrency')(row.coverageAmount);
                    row.marginFormatted = $filter('bbaCurrency')(row.margin);
                    row.excessFormatted = $filter('bbaCurrency')(row.excess);

                    row.carrierProfilesFormatted = {
                        type: 'multiLine',
                        list: row.carrierProfiles.length !== 0 ? row.carrierProfiles.map(cp => cp.carrierProfileName) : ['All']
                    };

                    row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Active' : 'Inactive'
                    };
                    row.actions = {
                        type: 'button',
                        buttons: [
                            {
                                text: 'View',
                                class: 'btn-primary',
                                action: data => {
                                    showRateDetailsModal(angular.copy(data));
                                }
                            },
                        ]
                    }
                    tableStructure.data.push(row);
                });
            }

            function showRateDetailsModal(data = null) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: '/templates/pages/transit-warranty/modal/transit-warranty-settings-modal.html',
                    controller: 'TransitWarrantyRateSettingsModal',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    resolve: {
                        details: () => data
                    }
                });

                modalInstance.result.then(() => {
                    tableActions.sendRequest({});
                });
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/transit-warranty/TransitWarrantyRatesTableService.js